
import React from 'react'
import Navbar from '../components/Navbar'; // adjust path if needed
import Sidebar from '../components/Sidebar';
import '../css/main.css';
import Donetable2 from '../components/Donetable2';


const CompleteTask = () => {
  return (
    <div className='container-dash bg-gray-50 min-h-screen'>
      <div className='flex'>
        <Sidebar />
        <div className='w-full'>
          <Navbar />
          <Donetable2 />
        </div>
      </div>
    </div>
  )
}

export default CompleteTask